import type { IBrandConfig } from './types';

const DEFAULT_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: { kind: 'legalPolicy', type: 'privacy' },
  termsOfService: { kind: 'legalPolicy', type: 'servicing' },
  websiteTermsOfUse: { kind: 'legalPolicy', type: 'terms' },
  refundPolicy: { kind: 'legalPolicy', type: 'refund' },
  idTheftProtection: { kind: 'none' },
  vaultProject: 'identity_guard',
  licensor: 'intersections',
  adaChat: false,
  accountDetails: true,
  personalInformation: true,
  secureUpload: true,
  billingDetails: true,
  offersAndUpgrades: true,
  security: true,
  dbooDeactivation: false,
  missingPII: true,
  finishSetup: true,
  showTheftText: true,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Intersections LLC dba Pango',
  hasCustomerServiceSupport: true,
  hidePhoneOnSignIn: false,
  showRedeemActivationCode: false,
  ssoRedirectURL: null,
  carouselBanners: true,
  /* No plan-upgrade banners unless a brand opts in. */
  planUpgradeBanners: {
    ultimate: false,
    family: false,
    requireRetailDtc: true,
  },
  /* Angular excludes brands from the upsell banner rather than opting them in,
     so the default is on and only the excluded brands say otherwise. */
  upsellBanner: true,
  dwEmailVerification: {
    adaChat: false,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default DEFAULT_BRAND_CONFIG;
